var React = require('react');

function Diamonds (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.2","y":"2.19","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -2.3714 5.7332)","className":"st0","width":"7.07","height":"7.07","key":0}),React.createElement("rect",{"x":"3.97","y":"6.46","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -4.1392 6.4654)","className":"st0","width":"3.54","height":"3.54","key":1}),React.createElement("polyline",{"className":"st0","points":"2.23,9.23 0.73,10.73 5.73,15.73 10.73,10.73 9.23,9.23 ","key":2})]);
}

Diamonds.defaultProps = {"version":"1.1","id":"Layer_1_copy_3","x":"0px","y":"0px","viewBox":"0 0 11.48 16.45","style":{"enableBackground":"new 0 0 11.48 16.45"},"xmlSpace":"preserve"};

module.exports = Diamonds;

Diamonds.default = Diamonds;
